import ArcGISMap from './ArcGISMap.json';
import COG from './COG.json';
import Bing from './Bing.json';
import GeoJSON from './GeoJSON.json';
import Group from './Group.json';
import XYZ from './XYZ.json';
import KML from './KML.json';
import OSM from './OSM.json';
import VectorTile from './VectorTile.json';
import Vector from './Vector.json';
import Tile from './Tile.json';
import WMS from './WMS.json';
import WFS from './WFS.json';
import WMTS from './WMTS.json';
import WMTSXYZ from './WMTSXYZ';


export default {
    "ArcGISMap": ArcGISMap,
    "BING": Bing,
    "COG": COG,
    "GeoJSON": GeoJSON,
    "GROUP": Group,
    "XYZ": XYZ,
    "KML": KML,
    "OSM": OSM,
    "VTILE": VectorTile,
    "VECTOR": Vector,
    "TileJSON": Tile,
    "WMS": WMS,
    "WFS": WFS,
    "WMTS": WMTS,
    "WMTSXYZ": WMTSXYZ
}